import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { RatePerClientForm } from '@/components/forms/RatePerClientForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateRatePerClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/rates-and-expenses/rate-per-client')
  }

  const handleCancel = () => {
    navigate('/rates-and-expenses/rate-per-client')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create Rate per Client</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new rate per client
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <RatePerClientForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

